export const REQUEST_FOLLOWEES = 'follow/REQUEST_FOLLOWEES';
export const RECEIVE_FOLLOWEES = 'follow/RECEIVE_FOLLOWEES';
export const CREATE_FOLLOWEE = 'follow/CREATE_FOLLOWEE';
export const DELETE_FOLLOWEE = 'follow/DELETE_FOLLOWEE';
export const REFRESH_FOLLOWEES = 'follow/REFRESH_FOLLOWEES';
